import routerOptions0 from "/home/runner/work/dartsspace/dartsspace/node_modules/.pnpm/nuxt@3.17.1_@capacitor+preferences@7.0.1_@capacitor+core@7.2.0__@netlify+blobs@8.2.0_@parcel+_iovcdhcvmsceb6pj4vmkrghb3i/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}